module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    class: _vm.modalState
  }, [_c('div', {
    staticClass: "modal__mask"
  }, [_c('div', {
    staticClass: "modal__wrapper"
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_vm._v("\n\t            " + _vm._s(_vm.modalTitle) + "\n\t          ")]), _vm._v(" "), (_vm.isOpen()) ? _c('div', {
    staticClass: "modal__body"
  }, [_c(_vm.currentView, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal__control"
  }, [_c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e9d52be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 330
// module chunks = 0